import api from '../utils/api';

const performanceService = {
  listReviews: async (staffId) => {
    try {
      return await api.get('/api/hr/performance-reviews', { params: staffId ? { staff_id: staffId } : {} });
    } catch (error) {
      console.error('Error fetching performance reviews:', error);
      throw error;
    }
  },

  createReview: async (data) => {
    try {
      return await api.post('/api/hr/performance-reviews', data);
    } catch (error) {
      console.error('Error creating performance review:', error);
      throw error;
    }
  },

  bulkLaunchReviews: async (data) => {
    try {
      return await api.post('/api/hr/performance-reviews/bulk-launch', data);
    } catch (error) {
      console.error('Error launching review cycle:', error);
      throw error;
    }
  },

  updateReview: async (reviewId, data) => {
    try {
      return await api.put(`/api/hr/performance-reviews/${reviewId}`, data);
    } catch (error) {
      console.error('Error updating performance review:', error);
      throw error;
    }
  },

  submitSelfAssessment: async (reviewId, data) => {
    try {
      return await api.put(`/api/hr/performance-reviews/${reviewId}/self-assessment`, data);
    } catch (error) {
      console.error('Error submitting self-assessment:', error);
      throw error;
    }
  },

  acknowledgeReview: async (reviewId) => {
    try {
      return await api.put(`/api/hr/performance-reviews/${reviewId}/acknowledge`, {});
    } catch (error) {
      console.error('Error acknowledging review:', error);
      throw error;
    }
  },

  changeStatus: async (reviewId, status) => {
    try {
      return await api.post(`/api/hr/performance-reviews/${reviewId}/status`, { status });
    } catch (error) {
      console.error('Error changing review status:', error);
      throw error;
    }
  },

  // ---- Staff goals (OKRs) ----

  listGoals: async (staffId) => {
    try {
      return await api.get('/api/hr/staff-goals', { params: staffId ? { staff_id: staffId } : {} });
    } catch (error) {
      console.error('Error fetching staff goals:', error);
      throw error;
    }
  },

  createGoal: async (data) => {
    try {
      return await api.post('/api/hr/staff-goals', data);
    } catch (error) {
      console.error('Error creating staff goal:', error);
      throw error;
    }
  },

  updateGoalProgress: async (goalId, data) => {
    try {
      return await api.patch(`/api/hr/staff-goals/${goalId}/progress`, data);
    } catch (error) {
      console.error('Error updating goal progress:', error);
      throw error;
    }
  },

  // ---- 360-degree peer feedback ----

  requestFeedback: async (reviewId, data) => {
    try {
      return await api.post(`/api/hr/performance-reviews/${reviewId}/feedback-requests`, data);
    } catch (error) {
      console.error('Error requesting 360 feedback:', error);
      throw error;
    }
  },

  myFeedbackRequests: async () => {
    try {
      return await api.get('/api/hr/feedback-requests/my');
    } catch (error) {
      console.error('Error fetching my feedback requests:', error);
      throw error;
    }
  },

  submitFeedback: async (requestId, data) => {
    try {
      return await api.post(`/api/hr/feedback-requests/${requestId}/submit`, data);
    } catch (error) {
      console.error('Error submitting feedback:', error);
      throw error;
    }
  },

  getAggregatedFeedback: async (reviewId) => {
    try {
      return await api.get(`/api/hr/performance-reviews/${reviewId}/feedback`);
    } catch (error) {
      console.error('Error fetching aggregated feedback:', error);
      throw error;
    }
  },

  // ---- Performance Improvement Plans ----

  listPips: async (staffId) => {
    try {
      return await api.get('/api/hr/performance-improvement-plans', { params: staffId ? { staff_id: staffId } : {} });
    } catch (error) {
      console.error('Error fetching performance improvement plans:', error);
      throw error;
    }
  },

  createPip: async (data) => {
    try {
      return await api.post('/api/hr/performance-improvement-plans', data);
    } catch (error) {
      console.error('Error creating performance improvement plan:', error);
      throw error;
    }
  },

  checkInPip: async (pipId, checkInNotes) => {
    try {
      return await api.patch(`/api/hr/performance-improvement-plans/${pipId}/check-in`, { check_in_notes: checkInNotes });
    } catch (error) {
      console.error('Error checking in on performance improvement plan:', error);
      throw error;
    }
  },

  closePip: async (pipId, data) => {
    try {
      return await api.patch(`/api/hr/performance-improvement-plans/${pipId}/close`, data);
    } catch (error) {
      console.error('Error closing performance improvement plan:', error);
      throw error;
    }
  },
};

export default performanceService;
